import functionList from "./function_list";

function applyFn(functionName, args) {
  const fn = functionList[functionName];
  return fn(...args);
}

export default applyFn;
